<ng-container *transloco="let t">

  <div class="modal-header">
    <h2>{{ header }}</h2>
    <!-- hack to fool ngbModal autofocus -->
    <input type="text" style="display:none" />
    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" aria-label="Close" (click)="activeModal.dismiss()">
      <span class="svg-icon svg-icon-2x">
        <close-x-svg-icon></close-x-svg-icon>
      </span>
    </div>
  </div>

  <div class="modal-body py-10 px-lg-17">
    <form #lienForm="ngForm" class="form" novalidate id="lienForm{{uniqueId}}" name="lienForm{{uniqueId}}">
      <div class="row align-items-end mb-8">
        <div class="col-md-6 fv-row">
          <label class="form-label mb-2 required" for="lienPosition{{uniqueId}}">{{ t('wizard.reo.lienPosition') }}</label>
          <select name="lienPosition" id="lienPosition{{uniqueId}}" class="form-select form-select-solid" required
            #lienPosition="ngModel" [(ngModel)]="lien.lienPosition"
            [ngClass]="{'is-invalid' : lienPosition && lienPosition.touched && lienPosition.invalid}">
            <option [ngValue]="null">{{ t('common.selectOne') }}</option>
            @for (position of lienPositionTypes; track position.value) {
              <option [ngValue]="position.value">{{ position.name }}</option>
            }
          </select>
          <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
        </div>
        <div class="col-md-6 fv-row">
          <label class="form-label mb-2 required" for="unpaidBalance{{uniqueId}}">{{ t('wizard.reo.lienBalance') }}</label>
          <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
            name="unpaidBalance" id="unpaidBalance{{uniqueId}}" required placeholder=""
            #unpaidBalance="ngModel" [(ngModel)]="lien.unpaidBalance"
            [ngClass]="{'is-invalid' : unpaidBalance && unpaidBalance.touched && unpaidBalance.invalid}" />
          <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
        </div>
      </div>
      <div class="row align-items-end mb-8">
        <div class="col-md-6 fv-row">
          <label class="form-label mb-2 required" for="holderName{{uniqueId}}">{{ t('wizard.reo.lienHolder') }}</label>
          <input type="text" class="form-control form-control-solid" name="holderName" id="holderName{{uniqueId}}"
            required maxlength="80" placeholder="" #holderName="ngModel" [(ngModel)]="lien.holderName"
            [ngClass]="{'is-invalid' : holderName && holderName.touched && holderName.invalid}" />
          <div class="invalid-feedback">{{ t('wizard.reo.fieldRequired') }}</div>
        </div>
        <div class="col-md-6 fv-row">
          <label class="form-label mb-2" for="accountNumber{{uniqueId}}">{{ t('wizard.reo.lienAccountNumber') }}</label>
          <input type="text" class="form-control form-control-solid" name="accountNumber" id="accountNumber{{uniqueId}}"
            maxlength="40" placeholder="" [(ngModel)]="lien.accountNumber" />
        </div>
      </div>
      @if (!inCoApplyFlow) {
        <div class="row mb-5">
          <div class="col-md-12 fv-row">
            <fieldset class="border-0 p-0 m-0">
              <legend class="required form-label mb-2 fs-6">{{ t('wizard.reo.lienBelongsTo') }}</legend>
              <div class="row" style="margin-left: 0;">
                @for (owner of possibleOwners; track owner.id) {
                  <div class="form-check form-check-custom form-check-solid mb-5 col-lg-6">
                    <input class="form-check-input" type="checkbox" id="lienOwner{{uniqueId}}-{{owner.id}}"
                      [checked]="isOwner(owner.id)" (change)="onOwnerToggled(owner.id, $any($event.target).checked)" />
                    <label class="form-check-label fs-6" for="lienOwner{{uniqueId}}-{{owner.id}}">{{ owner.name }}</label>
                  </div>
                }
              </div>
              @if (ownersTouched && !hasOwner) {
                <div class="text-danger fs-7">{{ t('wizard.reo.lienOwnerRequired') }}</div>
              }
            </fieldset>
          </div>
        </div>
      }
    </form>
  </div>

  <div class="modal-footer flex-center">
    <button type="button" class="btn btn-white me-3" (click)="activeModal.dismiss()">{{ t('common.cancel') }}</button>
    <button type="button" class="btn btn-primary" (click)="onSaveClicked()">{{ t('common.ok') }}</button>
  </div>

</ng-container>
